export default __webpack_public_path__ + "static/media/slide2.6b847f42.jpg";